"use client"

import { motion } from "@/components/motion/framer"
import { Typography } from "@/components/typography"
import { ReactNode } from "react"

interface PageHeroProps {
  eyebrow?: string
  title: string | ReactNode
  description: string
  className?: string
  illustration?: ReactNode
  buttons?: ReactNode
}

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0 },
}

export function PageHero({ eyebrow, title, description, className, illustration, buttons }: PageHeroProps) {
  const isCentered = className?.includes("text-center")
  
  return (
    <section className={`pt-0 pb-6 mb-12 md:mb-16 lg:mb-20 md:pt-0 md:pb-0 relative z-0 ${className || ""}`}>
      {illustration ? (
        <div className="grid gap-0 md:gap-8 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] items-center">
          {/* Illustration */}
          <div className="flex items-center justify-center order-2 md:order-1 w-full overflow-hidden">
            <div className="w-full max-w-[256px] md:max-w-none aspect-square md:w-full relative overflow-hidden">
              {illustration}
            </div>
          </div>
          
          {/* Text content */}
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeUp}
            transition={{ duration: 0.6 }}
            className={`space-y-4 order-1 md:order-2 ${isCentered ? "text-center md:text-left" : ""}`}
          >
            {eyebrow && (
              <Typography variant="eyebrow" className={isCentered ? "mx-auto md:mx-0" : ""}>
                {eyebrow}
              </Typography>
            )}
            {typeof title === "string" ? (
              <Typography variant="h1" as="h1" className={isCentered ? "mx-auto md:mx-0" : ""}>
                {title}
              </Typography>
            ) : (
              <div className={isCentered ? "mx-auto md:mx-0" : ""}>{title}</div>
            )}
            <Typography variant="body" className={`max-w-3xl text-tk-slate/80 ${isCentered ? "mx-auto md:mx-0" : ""}`}>
              {description}
            </Typography>
            {buttons && (
              <div className={`flex flex-wrap items-center gap-3 pt-2 ${isCentered ? "justify-center md:justify-start" : ""}`}>
                {buttons}
              </div>
            )}
          </motion.div>
        </div>
      ) : (
        <div className={`space-y-4 ${isCentered ? "text-center" : ""}`}>
      {eyebrow && (
            <Typography variant="eyebrow" className={isCentered ? "mx-auto" : ""}>
              {eyebrow}
            </Typography>
      )}
          {typeof title === "string" ? (
            <Typography variant="h1" as="h1" className={isCentered ? "mx-auto" : ""}>
              {title}
            </Typography>
          ) : (
            <div className={isCentered ? "mx-auto" : ""}>{title}</div>
          )}
          <Typography variant="body" className={`max-w-3xl text-tk-slate/80 ${isCentered ? "mx-auto" : ""}`}>
        {description}
      </Typography>
      {buttons && (
        <div className={`flex flex-wrap items-center gap-3 pt-2 ${isCentered ? "justify-center" : ""}`}>
          {buttons}
        </div>
      )}
    </div>
      )}
    </section>
  )
}

